module.exports = __webpack_public_path__ + "img/图片16.55fa5b4c.png";